import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Typography from '../components/Typography';
import poeta from '../img/clientes/poeta.jpg';
import admPC from '../img/clientes/admPerezCarreras.gif';
import brihet from '../img/clientes/BRIHET.jpg';
import circulo from '../img/clientes/circulo.jpg';
import asocverde from '../img/clientes/asociacionCivil.jpg';
import cmh from '../img/clientes/logoCMH.jpg';
import muchachos from '../img/clientes/muchachos.jpg';
import querer from '../img/clientes/QuererEsPOder.jpg';
import sanitrol from '../img/clientes/sanitrol2.jpg';
import hielo from '../img/clientes/sindicato.jpg';


const styles = theme => ({
  root: {
    display: 'flex',
    overflow: 'hidden',
    backgroundColor: theme.palette.secondary.light,
  },
  container: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(5),
    display: 'flex',
    position: 'relative',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(0, 5),
  },
  image: {
    height: 55,
  },
  title: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
  },
  curvyLines: {
    pointerEvents: 'none',
    position: 'absolute',
    top: -180,
  },
});

function ProductValues(props) {
  const { classes } = props;
  return (
    <section className={classes.root}>
      <Container className={classes.container}>
        <Grid container spacing={5}>
          <Grid item xs={12} md={12}>
            <Typography variant="h4" marked="center" align="center" component="h2">
              Algunos de nuestros clientes
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className={classes.item}>
              <img
                className={classes.image}
                src={poeta}
                alt="suitcase"
              />
              <Typography variant="h6" className={classes.title} align="center">
                Taller Mecanico Reno del Mar
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className={classes.item}>
              <img
                className={classes.image}
                src={admPC}
                alt="graph"
              />
              <Typography variant="h6" className={classes.title}  align="center">
                Administracion Perez Carreras
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className={classes.item}>
              <img
                className={classes.image}
                src={brihet}
                alt="clock"
              />
              <Typography variant="h6" className={classes.title}  align="center">
                Editorial Brihet Hermanos
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className={classes.item}>
              <img
                className={classes.image}
                src={muchachos}
                alt="clock"
              />
              <Typography variant="h6" className={classes.title}  align="center">
                Fabrica de pastas Los Muchachos
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className={classes.item}>
              <img
                className={classes.image}
                src={cmh}
                alt="clock"
              />
              <Typography variant="h6" className={classes.title}  align="center">
                Medicina Hiperbarica
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className={classes.item}>
              <img
                className={classes.image}
                src={circulo}
                alt="clock"
              />
              <Typography variant="h6" className={classes.title}  align="center">
                Circulo de Kinesiologos Distrito IX
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className={classes.item}>
              <img
                className={classes.image}
                src={hielo}
                alt="clock"
              />
              <Typography variant="h6" className={classes.title}  align="center">
                Sindicato del Hielo
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className={classes.item}>
              <img
                className={classes.image}
                src={asocverde}
                alt="clock"
              />
              <Typography variant="h6" className={classes.title}  align="center">
                Asociacion Civil Convivencia Verde
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className={classes.item}>
              <img
                className={classes.image}
                src={querer}
                alt="clock"
              />
              <Typography variant="h6" className={classes.title}  align="center">
                Asociacion Pro Hogares Maria Amalia Bustinza
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className={classes.item}>
              <img
                className={classes.image}
                src={sanitrol}
                alt="clock"
              />
              <Typography variant="h6" className={classes.title}  align="center">
                Sanitrol
              </Typography>
            </div>
          </Grid>
        </Grid>
      </Container>
    </section>
  );
}

ProductValues.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProductValues);
